import React from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import Text from '~/components/core/TextComponents/Text';

import type { SopConfigurationResponse } from './types';

interface SopCardProps {
  configuration: SopConfigurationResponse | null;
  isLoading: boolean;
  onConfigureClick: () => void;
  onViewClick?: () => void;
}

const SopCard: React.FC<SopCardProps> = ({ configuration, isLoading, onConfigureClick, onViewClick }) => {
  return (
    <div className="border-gray-300 flex items-center justify-between rounded-lg border bg-white p-16">
      <div>
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
          {`Organization's Standard Operating Procedures (SOP)`}
        </Text>
        <Text variant={Text.VARIANTS.XS} colorVariant={Text.COLOR_VARIANTS.SECONDARY} className="mt-4">
          {isLoading
            ? 'Loading...'
            : configuration
              ? `Configured • ${configuration.metadata?.page_count || 0} pages`
              : 'Paste here your Standard Operating procedures (SOP) to help Clive understand your internal policies.'}
        </Text>
      </div>
      <div className="flex gap-8">
        {configuration && onViewClick && (
          <Button variant="outlined" color="primary" onClick={onViewClick} disabled={isLoading}>
            View
          </Button>
        )}
        <Button variant="contained" color="primary" onClick={onConfigureClick} disabled={isLoading}>
          {configuration ? 'Replace' : 'Add'}
        </Button>
      </div>
    </div>
  );
};

export default SopCard;
